import { API_BASE_URL } from "../../config";
export const getImageUrl = (path) => {
  if (!path) return "";

  return `${API_BASE_URL}${path}`;
};